module.exports = __webpack_public_path__ + "img/how_con_03.1837de82.png";